import service from "./service"

const submitPreCheckConsent = async (data) => {
    return service(data)
}

export default submitPreCheckConsent
